<i18n>
{
  "en": {
    "hello": "Verification System"
  },
  "ja": {
    "hello": "手続きシステム"
  }
}
</i18n>

<template>
  <div>
    <Toolbar :title="campaign.name + $t('hello')" />
    <v-container>
      <v-layout row wrap align-center justify-center pt-5>
        <v-flex text-xs-center xs12 sm12 md8 lg8>
          <ProfileEditForm />
        </v-flex>
        <v-flex xs12 sm12 md12></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ProfileEditForm from '@/components/molecules/ProfileEditForm.vue';
import Toolbar from '@/components/molecules/Toolbar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ProfileEditForm,
    Toolbar
  },
  data() {
    return {
      campaignCode: this.$route.params.campaignCode
    };
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  methods: {
    ...mapActions(['initState', 'resolveCampaignCode', 'login'])
  }
};
</script>
